export default __webpack_public_path__ + "static/media/herocard2.ed1fda36.svg";